import moment = require("moment");
import { ETableActionType, ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants";
import { IFormKey, IFormSelectOption } from "src/app/modules/shared/models/forms";

export enum EDashboardStatus {
    DRAFT = 'DRAFT',
    TO_UPLOAD = 'TO_UPLOAD',
    DOC_SENT = 'DOC_SENT',
    COMPLETED = 'COMPLETED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING'
}

export type TDashboardStatus = keyof typeof EDashboardStatus;

export enum EOperationStatus {
    DRAFT = 'Bozza',
    TO_UPLOAD = 'Doc. da caricare',
    DOC_SENT = 'Doc. inviati',
    COMPLETED = 'Completata',
    REJECTED = 'Rifiutata',
    CANCELLED = 'Annullata',
    PENDING = 'In lavorazione'
}

export enum EOperationBadge {
    DRAFT = 'badge-yellow',
    PENDING = 'badge-yellow',
    TO_UPLOAD = 'badge-yellow',
    DOC_SENT = 'badge-yellow',
    CANCELLED = 'badge-red',
    COMPLETED = 'badge-green',
    REJECTED = 'badge-red',
    Annullata = 'badge-red'
}

export const ongoing_operations: EDashboardStatus[] = [
    EDashboardStatus.DRAFT,
    EDashboardStatus.TO_UPLOAD,
]

export const cannot_cancel_operations: EDashboardStatus[] = [
    EDashboardStatus.CANCELLED,
    EDashboardStatus.PENDING
];

export const dashboard_status_list: IFormSelectOption[] = [
    {
        key: EDashboardStatus.DRAFT,
        value: EOperationStatus.DRAFT
    },
    {
        key: EDashboardStatus.TO_UPLOAD,
        value: EOperationStatus.TO_UPLOAD
    },
    {
        key: EDashboardStatus.COMPLETED,
        value: EOperationStatus.COMPLETED
    },
    {
        key: EDashboardStatus.REJECTED,
        value: EOperationStatus.REJECTED
    }
]

export const dashboard_company_list: IFormSelectOption[] = [
    {
        key: '00056',
        value: 'Athora',
    },
    {
        key: '00043',
        value: 'Intesa Sanpaolo (Vita)',
    },
    {
        key: '00055',
        value: 'Intesa Sanpaolo (Life)',
    },
    {
        key: '00044',
        value: 'Intesa Sanpaolo (Previdenza)',
    },
];

export const dashboard_timeframe_list: IFormSelectOption[] = [
    {
        key: 'TODAY',
        value: 'Oggi'
    },
    {
        key: 'LAST_WEEK',
        value: 'Ultima settimana'
    },
    {
        key: 'LAST_MONTH',
        value: 'Ultimo mese'
    },
    {
        key: 'CUSTOM_DATES',
        value: 'Periodo personalizzato'
    }
]

export const dashboard_form_template = {
    operationId: '',
    userId: '',
    agencyCode: '',
    status: '',
    companies: '',
    timeframe: '',
    dateFrom: '',
    dateTo: ''
}

export const dashboard_form_keys: IFormKey[] = [
    {
        id: 'operation-id-field',
        controlName: 'operationId',
        label: 'Operazione',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'user-id-field',
        controlName: 'userId',
        label: 'Matricola',
        css: 'col-3'
    },
    {
        id: 'agency-code-field',
        controlName: 'agencyCode',
        label: 'Filiale',
        css: 'col-3'
    },
    {
        id: 'status-field',
        controlName: 'status',
        label: 'Stato',
        type: 'MULTIPLE_SELECT',
        css: 'col-3',
        options: dashboard_status_list
    },
    {
        id: 'companies-field',
        controlName: 'companies',
        label: 'Compagnia',
        type: 'MULTIPLE_SELECT',
        css: 'col-3',
        options: dashboard_company_list
    },
    {
        id: 'timeframe-field',
        controlName: 'timeframe',
        label: 'Periodo temporale',
        type: 'SELECT',
        css: 'col-3',
        options: dashboard_timeframe_list
    },
    {
        id: 'dateFrom-field',
        controlName: 'dateFrom',
        label: 'Data da',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'dateTo-field',
        controlName: 'dateTo',
        label: 'Data a',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    }
]

export const dashboard_table_keys: ITableKey[] = [
    {
        key: 'companyCode',
        label: 'Compagnia',
        type: 'IMAGE',
        sortable: true
    },
    {
        key: 'companyPolicyNumber',
        label: 'Polizza',
        sortable: true,
        type: 'TOOLTIP'
    },
    {
        key: 'bperPolicyNumber',
        label: 'Polizza BPER',
        sortable: true,
        type: 'TOOLTIP'
    },
    {
        key: 'operationDate',
        label: 'Data',
        sortable: true,
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        key: 'operationDescription',
        label: 'Operazione',
        sortable: true
    },
    {
        key: 'userId',
        label: 'Matricola',
        sortable: true
    },
    {
        key: 'userAgencyCode',
        label: 'Filiale/CED',
        sortable: true
    },
    {
        key: 'status',
        label: 'Stato',
        type: 'BADGE',
        sortable: true
    },
    {
        key: ETableActionType.DETAIL,
        label: '',
        type: 'ACTION_ICON',
        actionIcon: 'visibility',
        color: 'primary',
        showIconFieldName: 'showIcon'
    }
]

export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const INTERNAL_MOVEMENT_ID_REGEX = /^FRS[A-Za-z0-9]{7}$/;
